import React from 'react';
import { useAggregatedPositions } from './useAggregatedPositions';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { EmptyState } from '../../../../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { AllocationContent } from '../AllocationContent/AllocationContent';
import { HypotheticalReturn } from '../../../HypotheticalReturn/HypotheticalReturn';
import { useAssetAllocation } from '../../useAssetAllocation';
import { AccountPortfolioDTO } from '../../../../../../../../api/useAccountPortfolioQuery';
import { AssetAllocationDTO } from '../../../../../../../../api/useAccountsOptionsQuery';
import { AllocationTaxStatusDTO } from '../../../../../../../../api/useAccountsQuery';
import { useAccountFormContext } from '../../../../context/useAccountFormContext';

interface Props {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
  accountPortfolio?: AccountPortfolioDTO;
}

export const AggregatedPositions = ({ assetAllocationTaxStatus, accountPortfolio }: Props) => {
  const { data } = useAggregatedPositions({ assetAllocationTaxStatus });

  if (!data) {
    return (
      <Box py="24">
        <EmptyState />
      </Box>
    );
  }

  return (
    <AggregatedPositionsContent
      assetAllocationTaxStatus={assetAllocationTaxStatus}
      accountPortfolio={accountPortfolio}
      chartValues={data.chartValues}
    />
  );
};

interface AggregatedPositionsContentProps {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
  accountPortfolio?: AccountPortfolioDTO;
  chartValues: AssetAllocationDTO[];
}

const AggregatedPositionsContent = ({
  assetAllocationTaxStatus,
  accountPortfolio,
  chartValues,
}: AggregatedPositionsContentProps) => {
  const {
    data: { showHypotheticalReturn },
  } = useAssetAllocation(accountPortfolio);

  const { localSaveOptions } = useAccountFormContext();

  return (
    <>
      {(localSaveOptions ? localSaveOptions.showHypotheticalReturn : showHypotheticalReturn) && (
        <Box pt="16" maxWidth="50%">
          <HypotheticalReturn />
        </Box>
      )}

      <AllocationContent
        chartValues={chartValues}
        assetAllocationTaxStatus={assetAllocationTaxStatus}
        readOnly
      />
    </>
  );
};
